import React from 'react';
import { colors, colorExtensions, spacing, borderRadius, typography } from '../../styles/tokens';
import { ChannelStatus } from '../../api/channels';

interface SyncStatusBadgeProps {
  status: ChannelStatus;
}

export const SyncStatusBadge: React.FC<SyncStatusBadgeProps> = ({ status }) => {
  const { bg, fg, label } = getStatusStyles(status);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: spacing.xs,
        padding: `${spacing.xs} ${spacing.sm}`,
        backgroundColor: bg,
        color: fg,
        borderRadius: borderRadius.sm,
        fontSize: typography.small.fontSize,
        fontWeight: typography.small.fontWeight,
        textTransform: 'capitalize',
      }}
    >
      <span aria-hidden>{getIcon(status)}</span>
      {label}
    </span>
  );
};

const getStatusStyles = (status: ChannelStatus) => {
  switch (status) {
    case 'connected':
      return { bg: colorExtensions.successDark + '20', fg: colorExtensions.successDark, label: 'Connected' };
    case 'syncing':
      return { bg: colors.info + '20', fg: colors.info, label: 'Syncing' };
    case 'degraded':
      return { bg: colorExtensions.warningDark + '20', fg: colorExtensions.warningDark, label: 'Degraded' };
    case 'error':
      return { bg: colorExtensions.errorDark + '20', fg: colorExtensions.errorDark, label: 'Error' };
    case 'inactive':
      return { bg: colors.border, fg: colors.textSecondary, label: 'Inactive' };
    case 'active':
      return { bg: colorExtensions.successDark + '20', fg: colorExtensions.successDark, label: 'Active' };
    case 'disconnected':
    default:
      return { bg: colors.border, fg: colors.textSecondary, label: 'Disconnected' };
  }
};

const getIcon = (status: ChannelStatus) => {
  switch (status) {
    case 'connected':
      return '●';
    case 'syncing':
      return '↻';
    case 'degraded':
      return '▲';
    case 'error':
      return '✕';
    case 'disconnected':
    default:
      return '○';
  }
};
